import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'antd';
import styles from './styles.less';

const Badges = ({ featured, online, freeTrial }) => (
  <div className={styles.verifiedFreetrial}>
    {online ? (
      <div className={styles.online}>
        <Badge status="processing" color="#40a9ff" />
        <span>Online</span>
      </div>
    ) : null}
    {featured ? (
      <span className={styles.featured}>
        <img src="/static/images/course/featured.svg" alt="featured" />
        Featured
      </span>
    ) : null}
    {freeTrial ? (
      <span>
        <img src="/static/images/course/freeTrial.svg" alt="FreeTrial" />
        Free trial
      </span>
    ) : null}
  </div>
);

Badges.propTypes = {
  featured: PropTypes.bool,
  online: PropTypes.bool,
  freeTrial: PropTypes.bool,
};

Badges.defaultProps = {
  featured: false,
  freeTrial: false,
  online: false,
};

export default Badges;
